module.exports = __webpack_public_path__ + "static/img/brand-third-5.e70a7dd5.png";